
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M6.25 8.36a.3.3 0 01-.42.42c-.32-.31.15-.78.42-.42m4.7 0a.3.3 0 01-.28.52c-.35-.18-.05-.72.28-.52m4.71 0a.3.3 0 01-.32.5c-.33-.2 0-.72.32-.5"}}),_c('path',{attrs:{"d":"M17.49.75a3.26 3.26 0 013.26 3.26v9.15a3.33 3.33 0 01-3.33 3.15h-5.56l-5.55 4.44v-4.44H4.04a3.34 3.34 0 01-3.33-3.33h0v-9A3.29 3.29 0 014.04.75z"}})])])
          )
        }
      }
    